import { isNotNullOrUndefined, isNullOrUndefined } from './null-safety.js';

export class JSONUtils {
  static decodeNumber(data: unknown): number {
    const number = Number(data);
    if(typeof number === 'number' &&
        isNotNullOrUndefined(number) &&
        !isNaN(number) &&
        isFinite(number)) {
      return number;
    }

    throw new Error(`Invalid number: ${data}`);
  }

  static decodeNumberOrNull(data: unknown): number | null {
    return isNullOrUndefined(data) ? null : this.decodeNumber(data);
  }

  static decodeInteger(data: unknown): number {
    const number = this.decodeNumber(data);
    if(Number.isInteger(number)) {
      return number;
    }

    throw new Error(`Invalid integer: ${data}`);
  }

  static decodeIntegerOrNull(data: unknown): number | null {
    return isNullOrUndefined(data) ? null : this.decodeInteger(data);
  }

  static decodeDouble(data: unknown): number {
    return this.decodeNumber(data);
  }

  static decodeDoubleOrNull(data: unknown): number | null {
    return this.decodeNumberOrNull(data);
  }

  static decodeString(data: unknown): string {
    if(typeof data === 'string') {
      return data;
    }

    throw new Error(`Invalid string: ${JSON.stringify(data)}`);
  }

  static decodeStringOrNull(data: unknown): string | null {
    return isNullOrUndefined(data) ? null : this.decodeString(data);
  }

  static decodeStringOrNullOrUndefined(data: unknown): string | null | undefined {
    return isNullOrUndefined(data) ? data : this.decodeString(data);
  }

  static decodeBoolean(data: unknown): boolean {
    if(typeof data === 'boolean') {
      return data;
    }

    throw new Error(`Invalid boolean: ${JSON.stringify(data)}`);
  }

  static decodeBooleanOrNull(data: unknown): boolean | null {
    return isNullOrUndefined(data) ? null : this.decodeBoolean(data);
  }

  static decodeBooleanOrNullOrUndefined(data: unknown): boolean | null | undefined {
    return isNullOrUndefined(data) ? data : this.decodeBoolean(data);
  }

  static decodeRecord(data: unknown): Record<string, unknown> {
    if(typeof data === 'object' && data !== null) {
      return data as Record<string, unknown>;
    }

    throw new Error(`Invalid record: ${JSON.stringify(data)}`);
  }

  static decodeRecordOrNull(data: unknown): Record<string, unknown> | null {
    return isNullOrUndefined(data) ? null : this.decodeRecord(data);
  }

  static decodeRecordOrNullOrUndefined(data: unknown): Record<string, unknown> | null | undefined{
    return isNullOrUndefined(data) ? data : this.decodeRecord(data);
  }

  static decodeArray(data: unknown): Array<unknown> {
    if(Array.isArray(data) && isNotNullOrUndefined(data)) {
      return data as Array<unknown>;
    }

    throw new Error(`Invalid array: ${JSON.stringify(data)}`);
  }

  static decodeArrayOrNull(data: unknown): Array<unknown> | null {
    return isNullOrUndefined(data) ? null : this.decodeArray(data);
  }
}
